import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100%;
    background:url('${()=>window.basedir}/images/bkg${Math.ceil(Math.random()*3)}.jpg') no-repeat 50% 50%;
    background-size: cover;
`;

export const LoginBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 300px;
    background-color: #333;
    box-shadow: 0 2px 5px rgba(0,0,0, 0.5);
    position: relative;
    border: 2px solid #555;
    padding: 10px 0 10px 0;
`;

export const ErrorMessage = styled.div`
    width: 90%;
    background-color: ${props => props.theme.colors.error};
    color: #fff;
    font-size: 12px;
    text-align: center;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
`;

export const LinkIcon = styled.a`
    width: 100%;
    height: 90px;
    margin-bottom: 10px;
`;

export const Icon = styled.div`
    width: 100%;
    height: 90px;
    background: url('${()=>window.basedir}/logo.png') #333 no-repeat 50% 50%;
    background-size: contain;
    content: '';
    margin-bottom: 10px;
`;

export const Label = styled.div`
    width: 90%;
    color: #999;
    font-size:12px;
`;

export const DataInput = styled.input`
    width: 90%;
    background-color: transparent;
    border: 1px solid #666;
    height: 40px;
    margin-bottom: 20px;
    color: #fff;
    text-align: center;

    :focus {
        outline-color: rgba(255,266,266, 0.4);
    }
`;

export const Button = styled.button`
    border: 1px solid #555;
    background-color: transparent;
    border: 0;
    color: #555;
    height: 40px;
    width: 90%;
    text-transform: uppercase;
    margin-bottom: 10px;
    transition: all .5s ease 0s;

    &.active {
        cursor: pointer;
        border: 1px solid ${props => props.color || props.theme.colors.main};
        color: ${props => props.color || props.theme.colors.main};
    }

    &.active:hover {
        background-color: ${props => props.color || props.theme.colors.main};
        color: #fff;
    }
`;

export const LanguageSelector = styled.div`
    position: absolute;
    left: 100%;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 5px 5px 5px 0;
    background-color: #333;
    cursor: pointer;
`;

export const ColorSelection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    padding: 0 10px;
`;

export const ColorItem = styled.div.attrs(props => {return {
    style: {backgroundColor: props.color}
}})`
    height: 20px;
    width: 20px;
    margin-right: 5px;
    border-radius: 10px;
    border: 2px solid transparent;


    &:last-child {
        margin-right: 0;
    }

    &.selected {
        border: 2px solid #fff;
    }
`;

export const LanguageItem = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background: url('${()=>window.basedir}/images/lang_${props => props.icon}.png') no-repeat 50% 50%;
    background-size: cover;
    overflow: hidden;
    box-sizing: border-box;
    margin-bottom: 5px;
    border: 3px solid #999;

    &.active {
        border: 3px solid ${props => props.theme.colors.main}
    }
`;

export const Message = styled.a`
    color: #999;
    font-size: 14px;
    line-height: 18px;
    margin: 20px 5%;
`;

export const ForgotPassword = styled.a`
    color: #999;
    font-size: 14px;
    text-decoration: none;
    margin: 5px 0 20px;
`;

export const ForgotRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 90%;
`;